module.exports = __webpack_public_path__ + "static/media/GoogleSans-Regular.b5c77a6a.ttf";